import "./index.css"
export default function BotaoDesc(props){
    return(
        <div className="desconto">{props.desconto}</div>
    )
}

